import {Controller, Post, Body} from '@nestjs/common';
import {AgentService} from './agent.service';

/**
 * 智能体（Agent）控制器
 * 负责接收来自三端的高级任务调度与多模型协作请求
 */
@Controller('api/agent')
export class AgentController {
  constructor(private readonly agentService: AgentService) {}

  /**
   * 执行综合 Agent 自动化任务
   * @param body 请求体包含任务描述与上下文
   */
  @Post('run')
  async runTask(@Body() body: {task: string; context?: any}) {
    return {
      success: true,
      message: 'Agent task received',
      data: null,
    };
  }
}
